import { atom } from "recoil";

import keys from "./constants";

export const isSameEvalModalOpenedState = atom<boolean>({
  key: keys.IS_SAME_EVAL_MODAL_OPENED_STATE,
  default: false
});
export const sameEvalIdState = atom<string>({
  key: keys.SAME_EVAL_ID_STATE,
  default: ""
});

export const isConfictPlatform = atom<{ conflict: boolean; shouldPlatform: string }>({
  key: keys.IS_CONFLICT_PLATFORM,
  default: {
    conflict: false,
    shouldPlatform: ""
  }
});
